import { render, staticRenderFns } from "./assessment-new-for-assessment-company.vue?vue&type=template&id=83c6b0da&scoped=true&"
import script from "./assessment-new-for-assessment-company.vue?vue&type=script&lang=js&"
export * from "./assessment-new-for-assessment-company.vue?vue&type=script&lang=js&"
import style0 from "./assessment-new-for-assessment-company.vue?vue&type=style&index=0&lang=css&"
import style1 from "./assessment-new-for-assessment-company.vue?vue&type=style&index=1&id=83c6b0da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c6b0da",
  null
  
)

export default component.exports